<template>
  <div class="DListHeader">

    <div class="icon" v-if="iconType" :class="iconType">
    </div>

    <!-- 无链接标题 -->
    <div class="title-box" v-if="!isATitle">
      <div class="title">{{ title }}</div>
      <slot name="classify"></slot>
    </div>

    <div class="title-box" v-else>
      <a
        :href="aHref"
        target="_blank"
        class="title">{{ title }}</a>
      <slot name="classify"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DListHeader",
  props:{
    iconType:{
      type: String,
      default: ''
    },
    title:{
      type: String,
      default: '默认标题'
    },
    /* 是否是a链接标签 */
    isATitle:{
      type: Boolean,
      default: false
    },
    aHref:{
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.DListHeader{
  display: flex;
  align-items: center;

  .icon{
    margin-right: 24px;
    &.hot{
      @include BgImage(39px,46px,'3d/icon_hot.png');
      margin-right: 20px;
    }
    &.topic{
      @include BgImage(56px,41px,'3d/icon_topic.png');
      margin-right: 20px;
    }


    &.business{
      @include BgImage(68px,68px,'3d/icon_business.png');
    }
    &.ele{
      @include BgImage(68px,68px,'3d/icon_ele.png');
    }

    &.person{
      @include BgImage(68px,68px,'3d/icon_person.png');
    }
    &.poster{
      @include BgImage(68px,68px,'3d/icon_poster.png');
    }
    &.scene{
      @include BgImage(68px,68px,'3d/icon_scene.png');
    }

  }

  .title-box{
    .title{
      font-size: 32px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 42px;
      letter-spacing: 1px;
    }
  }
}
</style>


